var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import { makeStyles } from "../../styles/index";
import { Popup } from "../Popup/Popup";
import { MenuList } from "./MenuList";
var useStyles = makeStyles(function () { return ({
    root: {},
}); }, { name: 'SnMenu' });
/**
 * メニューコンポーネント。
 *
 * - コンテキストメニュー、アクションメニューのようなもの。
 * - ポップアップで操作一覧が表示される。
 */
export var Menu = function (props) {
    var open = props.open, anchorEl = props.anchorEl, onClose = props.onClose, children = props.children, className = props.className, others = __rest(props, ["open", "anchorEl", "onClose", "children", "className"]);
    var classes = useStyles(props);
    // 前回の値と比較し、true -> falseの変化の場合focusをanchorに移動する。
    var prevOpen = useRef(open);
    useEffect(function () {
        if (prevOpen.current === true && open === false && anchorEl instanceof HTMLElement) {
            anchorEl.focus();
        }
        prevOpen.current = open;
    }, [anchorEl, open]);
    return (React.createElement(Popup, __assign({ open: open, anchorEl: anchorEl, className: classNames(classes.root, className), onClickAway: onClose }, others),
        React.createElement(MenuList, { autoFocusItem: open, onCancel: onClose, onNext: onClose, onPrev: onClose }, children)));
};
